import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@heidi/design-system/form';
import { Textarea } from '@heidi/design-system/textarea';
import { TypographyP2Bold } from '@heidi/design-system/typography';
import { type Control } from 'react-hook-form';
import { type z } from 'zod';
import { type PatientProfileFormSchema } from '../../../contracts';
import { type patientTextareaFieldNames } from '../../patient-context/useExtendedPatientProfileFields';

interface PatientTextareaFieldProps {
  name: patientTextareaFieldNames;
  label: string;
  placeholder: string;
  isDisabled: boolean;
  control: Control<z.infer<typeof PatientProfileFormSchema>>;
  className?: string;
}

export const PatientTextareaField = ({
  name,
  label,
  placeholder,
  isDisabled,
  control,
  className,
}: PatientTextareaFieldProps) => {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex flex-col gap-1">
          <FormLabel>
            <TypographyP2Bold>{label}</TypographyP2Bold>
          </FormLabel>
          <FormControl>
            <Textarea
              disabled={isDisabled}
              {...field}
              placeholder={placeholder}
              maxLength={1000}
              className={className}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
